module.exports = __webpack_public_path__ + "media/images/default/pages/shared/arrow_downward-bddc5ebcf43d6c3ef0858155e577fdec.svg";